import { CIRCLE_RADIUS, LINE_THICKNESS } from "../../utils/constants";
import { motion } from "framer-motion";

export default function AnimatedLine({ start, end }) {
  const isValidPoint = (p) =>
    p && Number.isFinite(p.x) && Number.isFinite(p.y);

  if (!isValidPoint(start) || !isValidPoint(end)) {
    return null;
  }

  return (
    <motion.g
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
    >
      <line
        x1={start.x}
        y1={start.y}
        x2={end.x}
        y2={end.y}
        stroke="currentColor"
        strokeWidth={LINE_THICKNESS}
      />
      <circle
        cx={start.x}
        cy={start.y}
        r={CIRCLE_RADIUS}
        fill="currentColor"
      />
      <circle
        cx={end.x}
        cy={end.y}
        r={CIRCLE_RADIUS}
        fill="currentColor"
      />
    </motion.g>
  );
}
